export default "__VITE_ASSET__li_HsdL___"